import { LOCALES } from './locales'

// TODO ! add number formatting utils func
export const PHONE_NUMBER = {
  [LOCALES.en]: '+998(78)122-62-26',
  [LOCALES.ru]: '+7(800)333-71-38',
  [LOCALES.uz]: '+998(78)122-62-26',
  [LOCALES.kk]: '+7(727)311-09-11'
} as const
